import styled from 'styled-components';
import { Blue, Gray, White } from '../../colors';
export const Container = styled.div `
    border-width: 0;
    padding: 10px 0;
    display: flex;
    
    div {
      width: 30px;
    }
`;
export const Label = styled.label `
    font-family: Inter;
    font-weight: 500;
    color: ${Blue.dark};
    margin-top: 3px;
`;
export const RadioInput = styled.input `
  margin-right: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: ${Gray.dark};
  box-sizing: border-box;
  border: 2px solid ${Gray.dark};
  background: ${White.normal};
  -webkit-appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:hover, &:focus {
    border: 2px solid ${Blue[2]};
    background: ${Blue[5]};
    box-shadow: 0px 0px 0px 6px ${Blue[5]};
  }

  &:checked {
    border: 2px solid ${Blue[2]};

    &::after {
      content: "";
      width: 10px;
      height: 10px;
      margin: 3px;
      display: block;
      border-radius: 50%;
      background: ${Blue[2]};
    }
  }

  &:disabled {
    background: ${Gray.light};
    border: 2px solid ${Gray.light};

    &::after {
      background: ${Gray.normal};
    }
  }
`;
//# sourceMappingURL=RadioButton.Styled.js.map